module.exports = __webpack_public_path__ + "bd6a981f465a03ac76d68c09c7aae2fc.pdf";